import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center m-5 flex-grow" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-4xl mb-4 text-center text-fau-blue-bright font-light" }
const _hoisted_5 = { class: "whitespace-nowrap font-bold" }
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = { class: "text-red-500" }

import { ref, onMounted, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import Auth from "@/modules/Auth/Auth";
import FormAPI, { FormMeta } from "@/modules/Auth/APIs/FormAPI";
import Footer from "./Footer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ["is-page-loaded"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("is-page-loaded", false);

const APIHOST: string = process.env.VUE_APP_BACKEND_URL;

const router = useRouter();
const route = useRoute();
const auth = inject("auth") as Auth;

const errorMessage = ref<string>();

const formMeta = ref<FormMeta>();

function signIn() {
    auth.SignInWithRedirect();
}

function LoadLoginForm() {
    var formId: string | undefined = route.query.redirect?.toString();

    if (formId == undefined) {
        router.push({
            path: "/",
        });
        return;
    }
    // remove the first character as it's a '/'
    formId = formId.substring(1, formId.length);

    
    const formAPI = new FormAPI(auth);

    formAPI.GetFormMeta(formId)
        .then((result) => {
            //console.log(result)

            formMeta.value = result;
            emit("is-page-loaded", true);
        })
        .catch((error) => {
            console.error("Failed to get form meta", error);
            errorMessage.value = error.message;
        });
}

// only on client side
onMounted(() => {    
    auth.HandleRedirect()
        .then((result) => {
            if(!result){
                LoadLoginForm();
                return;
            }
            console.log("Redirect handled", result);
            router.push({
                    path: route.query.redirect?.toString() ?? "",
                });
        })
        .catch((error) => {
            console.error("Failed to handle redirect", error);
            errorMessage.value = error.message;
            LoadLoginForm();
        });   
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(APIHOST) + '/images/two-folks-looking-at-target.svg',
        class: "w-1/2 md:max-w-64",
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("h1", _hoisted_4, [
        _cache[0] || (_cache[0] = _createTextVNode(" Welcome to our ")),
        _createElementVNode("span", _hoisted_5, _toDisplayString(formMeta.value?.displayName) + " Form", 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-lg" }, "Please sign in to continue", -1)),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: signIn,
        class: "mt-4 bg-fau-blue-bright text-white px-4 py-2 rounded-md"
      }, " Sign in with your FAU account ")
    ]),
    _createVNode(Footer)
  ]))
}
}

})